import { render, staticRenderFns } from "./DotsCircle.vue?vue&type=template&id=f28c1d00"
import script from "./DotsCircle.vue?vue&type=script&lang=js"
export * from "./DotsCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports